import React from 'react'
import Footer from '../components/Footer'
import rk from '../components/img/rk.jpg'

const About = () => {
    return (
        <>

            <div className='section'>

                <img src={rk} />
            </div>

            <Footer />

        </>
    )
}

export default About